import { render, staticRenderFns } from "./ModalTransfersPagando.vue?vue&type=template&id=e0310b14"
import script from "./ModalTransfersPagando.vue?vue&type=script&lang=js"
export * from "./ModalTransfersPagando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports